import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { getTotalGuestsQtyFromHotelOccupationArray } from "@lib/util/hotels/search-ops";
import { HOTELS_MAX_GUEST_IN_RESERVATION, HOTELS_MAX_ROOMS_IN_RESERVATION } from "@lib/constants";
import { useMobileFilters } from "@lib/context/mobile/filters-context";
import { MuscleButton } from "@modules/shared/components/buttons";
import InformativeCard from "@modules/shared/components/cards/informative";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { cn } from "@lib/cn";
import Icons from "@modules/icons";
import useAfterInitEffect from "@lib/hooks/use-after-initialization-effect";
import useCssModules from "@lib/hooks/use-css-modules";
import { OccupationInput } from "./partials/ocuppation-inputs";
import { usePathname } from "next/navigation";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
export const GuestSelectionView = () => {
  const t = useTranslations("Hotels");
  const {
    hotelsFilters
  } = useMobileFilters();
  const {
    togglePanel
  } = useSideOverPanel();
  const pathname = usePathname();
  const {
    cssModules
  } = useCssModules();
  const {
    setNode
  } = useForwardNode();
  const {
    guestSelectionPanelContainer,
    guestSelectionHeaderTitle,
    guestSelectionHeaderButton,
    guestSelectionApplyButtonContainer,
    guestSelectionOccupationInputsContainer,
    guestSelectionHeaderContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.GuestSelection) || {};
  const {
    exitIconClassName,
    clearTextClassName,
    clearIconClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.sideOverPanel) || {};

  // Use shared context state for occupations
  const {
    selectedOccupations,
    setSelectedOccupations
  } = hotelsFilters;

  // Validation states
  const {
    0: errorMessage,
    1: setErrorMessage
  } = useState("");
  const {
    0: showCompleteChildrenAges,
    1: setShowCompleteChildrenAges
  } = useState(false);

  // Computed values
  const totalGuestsInReservation = getTotalGuestsQtyFromHotelOccupationArray(selectedOccupations);
  const allChildrenAgesEntered = selectedOccupations.every(occupation => !occupation.children_ages.includes(null));
  const canAddRoom = totalGuestsInReservation < HOTELS_MAX_GUEST_IN_RESERVATION && selectedOccupations.length < HOTELS_MAX_ROOMS_IN_RESERVATION;

  // No need for debounced update since we're using shared context

  // Update validation
  useEffect(() => {
    // Validate children ages
    if (!allChildrenAgesEntered) {
      setErrorMessage(t("InputsBar.ERRORS.COMPLETE_CHILDREN_AGES"));
    } else {
      setErrorMessage("");
    }
  }, [selectedOccupations, allChildrenAgesEntered, t]);

  // Use shared context methods
  const {
    addOccupation,
    removeOccupation,
    updateOccupation
  } = hotelsFilters;
  useAfterInitEffect(() => {
    if (!hotelsFilters.isHotelsOpen) {
      if (!allChildrenAgesEntered) {
        hotelsFilters.setIsHotelsOpen(true);
        setShowCompleteChildrenAges(true);
      } else {
        setShowCompleteChildrenAges(false);
      }
    }
  }, [hotelsFilters.isHotelsOpen, allChildrenAgesEntered, hotelsFilters.setIsHotelsOpen]);
  const handleClear = () => {
    setSelectedOccupations([{
      adults: 1,
      children: 0,
      children_ages: []
    }]);
  };
  const renderOccupationInputs = () => {
    return selectedOccupations.map((occupation, index) => {
      return __jsx(OccupationInput, {
        key: index,
        index: index,
        occupation: occupation,
        updateThisOccupation: occupation => updateOccupation(index, occupation),
        removeThisOccupation: () => removeOccupation(index),
        otherOccupations: selectedOccupations.filter((_, i) => i !== index)
      });
    });
  };
  return __jsx("div", {
    className: guestSelectionPanelContainer
  }, __jsx("div", {
    className: guestSelectionHeaderContainer
  }, __jsx("div", {
    className: "flex items-center gap-[7px]"
  }, __jsx("button", {
    onClick: () => togglePanel()
  }, __jsx(XMarkIcon, {
    className: exitIconClassName,
    "aria-hidden": "true"
  })), __jsx("h2", {
    className: guestSelectionHeaderTitle
  }, t("ROOMS_TITLE"))), __jsx("button", {
    onClick: handleClear,
    className: cn(clearTextClassName, 'flex items-center gap-1')
  }, __jsx(Icons.trashcanV2, {
    className: clearIconClassName
  }), t("CLEAR"))), __jsx("div", {
    className: guestSelectionOccupationInputsContainer
  }, renderOccupationInputs(), errorMessage && __jsx(InformativeCard, {
    message: errorMessage,
    severity: "danger"
  })), __jsx("div", {
    className: guestSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: addOccupation,
    disabled: !canAddRoom
  }, __jsx(Icons.circlePlusOutline, {
    className: "min-w-4 min-h-4"
  }), t("InputsBar.ADD_ROOM")), __jsx(MuscleButton, {
    variant: "solidXL",
    onClick: () => togglePanel()
  }, t("InputsBar.APPLY")), pathname.includes("/hotels/search") && __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => setNode("EditHotelSelection")
  }, t("InputsBar.MAKE_CHANGES"))));
};